import { all, call, select, takeLatest } from 'redux-saga/effects';
import { createAsyncSaga } from '@wahaaabello/redux-async-actions';
import uiActions from './actions';
import { getShowSidebar } from './reducer';
import SessionStorage from '../../../storage';

function* toggleSidebar() {
  const showSidebar = yield select(getShowSidebar);
  yield call(SessionStorage.setItem, 'showSidebar', showSidebar);
}

export default function* uiSaga() {
  yield all([
    takeLatest(
      uiActions.toggleSidebar.toString(),
      createAsyncSaga(toggleSidebar)
    )
  ]);
}
